// extracted by mini-css-extract-plugin
export var banner = "_2d-0";
export var icon = "_2d-1";
export var message = "_2d-2";